import { render, staticRenderFns } from "./IcePopSelector.vue?vue&type=template&id=36056022&scoped=true"
import script from "./IcePopSelector.vue?vue&type=script&lang=js"
export * from "./IcePopSelector.vue?vue&type=script&lang=js"
import style0 from "./IcePopSelector.vue?vue&type=style&index=0&id=36056022&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36056022",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36056022')) {
      api.createRecord('36056022', component.options)
    } else {
      api.reload('36056022', component.options)
    }
    module.hot.accept("./IcePopSelector.vue?vue&type=template&id=36056022&scoped=true", function () {
      api.rerender('36056022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IcePopSelector/IcePopSelector.vue"
export default component.exports